import { render, staticRenderFns } from "./ReviewReturnSummary.vue?vue&type=template&id=c9440364&"
import script from "./ReviewReturnSummary.vue?vue&type=script&lang=js&"
export * from "./ReviewReturnSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReviewReturnSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports